import { useState } from "react";
import SidenavItem from "./SidenavItem";
import { GoDot } from "react-icons/go";

const SidenavDesktop = ({Menus, logo}) => {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [open, setOpen] = useState(true);
  const [hoverOpen, setHoverOpen] = useState(false);
    
  return (
    <div className={`${open ? "w-72" : "w-20"} flex`}>
        <div
          className={`${
            hoverOpen || open ? "w-72" : "w-20"
          } p-5 pt-9  bg-gray  duration-300 h-screen fixed top-0 left-0 bottom-0 overflow-y-auto z-10 bg-white dashboard-sidenav`}
          onMouseEnter={() => setHoverOpen(true)}
          onMouseLeave={() => setHoverOpen(false)}
        >
          <div
            className={`inline-flex ${
              hoverOpen || open ? "w-72" : "w-20"
            } transition-all px-4 py-4 justify-between items-center fixed top-0 left-0 bg-white z-10`}
          >
            <div className="inline-flex gap-2">
              <img
                className={`object-contain ${
                  hoverOpen || open ? "hidden" : "mt-[0.34rem] h-12"
                }`}
                src={logo || "/assets/logo/imdady_logo_small.png"}
                alt=""
              />
              <img
                className={`${hoverOpen || open ? "" : "hidden"} h-12`}
                src={logo || "/assets/logo/imdady_logo.png"}
                alt=""
              />
            </div>
            <span className={`${hoverOpen || open ? "" : "hidden"}`}>
              <label
                className="relative flex items-center p-3 rounded-full cursor-pointer"
                htmlFor="customStyle"
              >
                <input
                  type="checkbox"
                  className="before:content[''] peer relative h-4 w-4 cursor-pointer appearance-none rounded-full border border-gray-900/20 bg-gray-900/10 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-6 before:w-6 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-400 checked:bg-gray-400 checked:before:bg-gray-400 hover:scale-105 hover:before:opacity-0"
                  id="customStyle"
                  onChange={(e) => setOpen(e.target.checked)}
                  defaultChecked
                />
                <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                  <GoDot className="h-5 w-5" />
                </span>
              </label>
            </span>
          </div>
          <ul className="pt-2 mt-8">
            {Menus.map(
              (menu, index) =>
                user?.user.module_access &&
                JSON.parse(user?.user.module_access).includes(menu.title) && (
                  <SidenavItem
                    key={index}
                    menu={menu}
                    open={open}
                    hoverOpen={hoverOpen}
                    user={user}
                  />
                )
            )}
          </ul>
        </div>
      </div>
  )
}

export default SidenavDesktop